import i18n from '../i18n';

const state = {
  siteWidth: 1240,
  companyDetails: [
    { title: 'nameOfTheCompany', value: 'TMX Mobile Solution Szerviz Szolgáltató Korlátolt Felelősségű Társaság' },
    { title: 'headquarterOfTheCompany', value: '2040 Budaörs, Kinizsi utca 2/B.' },
    { title: 'sitesOfTheCompany', value: '1085 Budapest, József körút 17. fszt. 2., 5465 Cserkeszőlő, Fürdő utca 16.' },
    { title: 'postalAddressOfTheCompany', value: '2040 Budaörs, Kinizsi utca 2/B.' },
    { title: 'phoneNumberOfTheCompany', value: '+36-20/315-0766' },
    { title: 'telefaxNumberOfTheCompany', value: '+36-23/801-706' },
    { title: 'emailOfTheCompany', value: 'info@tmx.hu' },
    { title: 'VATNumberOfTheCompany', value: 'HU23059940' },
    { title: 'webhostDetails', value: 'TMX Mobile Solution Szerviz Szolgáltató Korlátolt Felelősségű Társaság', extra: '2040 Budaörs, Kinizsi utca 2/B.' },
  ],
  // tmxStores = GeoJson
  // googlemap-hoz is használható ebben a formában
  divisions: [
    { text: 'Adminisztráció', value: 1 },
    { text: 'Call center ügyintézés', value: 2 },
    { text: 'IT', value: 3 },
    { text: 'Logisztika', value: 4 },
    { text: 'Munka/HR', value: 5 },
    { text: 'Pénzügy', value: 6 },
    { text: 'Raktár', value: 7 },
    { text: 'Sales', value: 8 },
    { text: 'Szerviz', value: 9 },
    { text: 'Teszt', value: 10 },
    { text: 'Ügyfélszolgálat', value: 11 },
    { text: 'Egyéb', value: 12 },
  ],
  topics: [
    { text: 'Általános javítási információk', value: 1 },
    { text: 'Érdeklődés, javításra leadott készülékekről', value: 2 },
    { text: 'Fizetős javításokkal és/vagy árajánlatokkal kapcsolatos információk', value: 3 },
    { text: 'Készülékbiztosítás', value: 4 },
    { text: 'Reklamáció', value: 5 },
    { text: 'Egyéb témakör', value: 6 },
  ],
  topicsEN: [
    { text: 'General Repair Information', value: 1 },
    { text: 'Inquiry about Devices for Repair', value: 2 },
    { text: 'Information on Paid Repairs and / or Quotes', value: 3 },
    { text: 'Equipment Insurance', value: 4 },
    { text: 'Complaint', value: 5 },
    { text: 'Other Topic', value: 6 },
  ],
  topicsDE: [
    { text: 'Allgemeine Reparaturinformationen', value: 1 },
    { text: 'Anfragen zu Reparaturgeräten', value: 2 },
    { text: 'Informationen zu bezahlten Reparaturen und / oder Angeboten', value: 3 },
    { text: 'Versicherung', value: 4 },
    { text: 'Reklamation', value: 5 },
    { text: 'Sonstige Themen', value: 6 },
  ],
  manufacturer: [
    { text: 'Alcatel', value: 1 },
    { text: 'ASUS', value: 2 },
    { text: 'Blaupunkt', value: 3 },
    { text: 'Boway', value: 4 },
    { text: 'CAT', value: 5 },
    { text: 'Coolpad', value: 6 },
    { text: 'Emporia', value: 7 },
    { text: 'Evolveo', value: 8 },
    { text: 'GSMART', value: 9 },
    { text: 'HTC', value: 10 },
    { text: 'HTM', value: 11 },
    { text: 'Huawei', value: 12 },
    { text: 'Lenovo/Moto', value: 13 },
    { text: 'LG', value: 14 },
    { text: 'NOKIA', value: 15 },
    { text: 'OnePLus', value: 16 },
    { text: 'Polaroid', value: 17 },
    { text: 'Posh', value: 18 },
    { text: 'Samsung', value: 19 },
    { text: 'Telme', value: 20 },
    { text: 'Unitone', value: 21 },
    { text: 'Xiaomi', value: 22 },
    { text: 'ZTE', value: 23 },
    { text: 'Egyéb', value: 24 },
  ],
  manufacturerEN: [
    { text: 'Alcatel', value: 1 },
    { text: 'ASUS', value: 2 },
    { text: 'Blaupunkt', value: 3 },
    { text: 'Boway', value: 4 },
    { text: 'CAT', value: 5 },
    { text: 'Coolpad', value: 6 },
    { text: 'Emporia', value: 7 },
    { text: 'Evolveo', value: 8 },
    { text: 'GSMART', value: 9 },
    { text: 'HTC', value: 10 },
    { text: 'HTM', value: 11 },
    { text: 'Huawei', value: 12 },
    { text: 'Lenovo/Moto', value: 13 },
    { text: 'LG', value: 14 },
    { text: 'NOKIA', value: 15 },
    { text: 'OnePLus', value: 16 },
    { text: 'Polaroid', value: 17 },
    { text: 'Posh', value: 18 },
    { text: 'Samsung', value: 19 },
    { text: 'Telme', value: 20 },
    { text: 'Unitone', value: 21 },
    { text: 'Xiaomi', value: 22 },
    { text: 'ZTE', value: 23 },
    { text: 'Other Brand', value: 24 },
  ],
  services: [
    {
      id: 'sLog',
      img: 'logisztika_kep1',
      title: 'serviceBox.logistics',
      desc: 'serviceBox.logisticsDesc',
      button: {
        path: 'services',
        text: null,
      },
    },
    {
      id: 'sPre',
      img: 'presales_kep2',
      title: 'serviceBox.preSales',
      desc: 'serviceBox.preSalesDesc',
      button: {
        path: 'services',
        text: null,
      },
    },
    {
      id: 'sNet',
      img: 'halozat_kep3',
      title: 'serviceBox.networkManagement',
      desc: 'serviceBox.networkManagementDesc',
      button: {
        path: 'services',
        text: null,
      },
    },
    {
      id: 'sRep',
      img: 'javitas_kep4',
      title: 'serviceBox.repair',
      desc: 'serviceBox.repairDesc',
      button: {
        path: 'javitas',
        text: null,
      },
    },
  ],
  partners: [
    {
      img_path: 'telekom.png',
      title: 'Telekom',
      linkUrl: 'https://www.telekom.hu/lakossagi',
    },
    {
      img_path: 'telenor.png',
      title: 'Telenor',
      linkUrl: 'https://www.telenor.hu/',
    },
    {
      img_path: 'vodafone.png',
      title: 'Vodafone',
      linkUrl: 'https://www.vodafone.hu/',
    },
    {
      img_path: 'chubb.png',
      title: 'Vodafone',
      linkUrl: 'https://www.chubb.com/hu-hu/',
    },
    {
      img_path: 'aegon.png',
      title: 'AEGON',
      linkUrl: 'https://www.aegon.hu/',
    },
    {
      img_path: 'triglav.png',
      title: 'Triglav',
      linkUrl: 'http://www.triglav.eu/en',
    },
    {
      img_path: 'alcatel.png',
      title: 'Alcatel',
      linkUrl: 'https://www.alcatelmobile.com/hu/',
    },
    {
      img_path: 'asus.png',
      title: 'Asus',
      linkUrl: 'https://www.asus.com/hu/',
    },
    {
      img_path: 'blackberry.png',
      title: 'BlackBerry',
      linkUrl: 'https://www.blackberry.com/us/en',
    },
    {
      img_path: 'blaupunkt.png',
      title: 'Blaupunkt',
      linkUrl: null,
    },
    {
      img_path: 'cat.png',
      title: 'CAT',
      linkUrl: 'https://www.catphones.com/',
    },
    {
      img_path: 'd_link.png',
      title: 'D-Link',
      linkUrl: null,
    },
    {
      img_path: 'evolveo.png',
      title: 'Evolveo',
      linkUrl: null,
    },
    {
      img_path: 'go_pro.png',
      title: 'GoPro',
      linkUrl: 'https://gopro.com',
    },
    {
      img_path: 'gsmart.png',
      title: 'GSmart',
      linkUrl: null,
    },
    {
      img_path: 'htc.png',
      title: 'HTC',
      linkUrl: 'https://www.htc.com/hu/',
    },
    {
      img_path: 'huawei.png',
      title: 'Huawei',
      linkUrl: 'http://www.huawei.hu/',
    },
    {
      img_path: 'kodak.png',
      title: 'Kodak',
      linkUrl: 'https://bullitt-group.com/',
    },
    {
      img_path: 'land_rover.png',
      title: 'Land Rover',
      linkUrl: 'https://bullitt-group.com/',
    },
    {
      img_path: 'lenovo_black.png',
      title: 'Lenovo',
      linkUrl: 'https://www.lenovo.com',
    },
    {
      img_path: 'lg.png',
      title: 'LG',
      linkUrl: 'https://www.lg.com/hu',
    },
    {
      img_path: 'navon.png',
      title: 'Navon',
      linkUrl: 'https://smartnavon.eu/',
    },
    {
      img_path: 'one_plus.png',
      title: 'OnePlus',
      linkUrl: null,
    },
    {
      img_path: 'samsung.png',
      title: 'Samsung',
      linkUrl: 'https://www.samsung.com/hu/',
    },
    {
      img_path: 'xiaomi.png',
      title: 'Xiaomi',
      linkUrl: 'https://www.mi.com/global',
    },
    {
      img_path: 'colonnade.png',
      title: 'Colonnade',
      linkUrl: 'https://colonnade.hu/',
    },
    {
      img_path: 'mvm.png',
      title: 'MVM',
      linkUrl: 'http://mvm.hu/',
    },
    {
      img_path: 'exim.png',
      title: 'Exim',
      linkUrl: 'https://exim.hu/',
    },
    {
      img_path: 'hvs.png',
      title: 'HVS Trade Kft.',
      linkUrl: 'http://hvstrade.hu/',
    },
    {
      img_path: 'mkb.png',
      title: 'MKB Bank Zrt.',
      linkUrl: 'https://www.mkb.hu/lakossagi',
    },
    {
      img_path: 'provident.png',
      title: 'Provident Pénzügyi Zrt.',
      linkUrl: 'https://www.provident.hu/',
    },
  ],
  whyUs: [
    {
      icon: 'mdi-arrow-right-circle',
      title: 'whyUs.quickRepair',
      desc: 'whyUs.quickRepairDesc',
    },
    {
      icon: 'mdi-arrow-right-circle',
      title: 'whyUs.highQuality',
      desc: 'whyUs.highQualityDesc',
    },
    {
      icon: 'mdi-arrow-right-circle',
      title: 'whyUs.nationwideNetwork',
      desc: 'whyUs.nationwideNetworkDesc',
    },
    {
      icon: 'mdi-arrow-right-circle',
      title: 'whyUs.customerOrientation',
      desc: 'whyUs.customerOrientationDesc',
    },
    {
      icon: 'mdi-arrow-right-circle',
      title: 'whyUs.friendlyAtmosphere',
      desc: 'whyUs.friendlyAtmosphereDesc',
    },
  ],
  warrantyType: [
    {
      id: 1,
      name: 'Garanciális javítás',
    },
    {
      id: 2,
      name: 'Fizetős javítás',
    },
    {
      id: 3,
      name: 'Biztosításos javítás',
    },
  ],
  warrantyTypeEN: [
    {
      id: 1,
      name: 'In warranty service',
    },
    {
      id: 2,
      name: 'Out of warranty service',
    },
    {
      id: 3,
      name: 'Insurance repair',
    },
  ],
  warrantyTypeDE: [
    {
      id: 1,
      name: 'Garantiereparatur',
    },
    {
      id: 2,
      name: 'Nein Garantiereparatur',
    },
    {
      id: 3,
      name: 'Versicherung repartur',
    },
  ],
  simLock: [
    { id: 1, name: 'Független' },
    { id: 2, name: 'Magyar Telekom' },
    { id: 3, name: 'Telenor' },
    { id: 4, name: 'Vodafone' },
    { id: 5, name: 'Egyéb' },
  ],
  simLockEN: [
    { id: 1, name: 'Unlocked' },
    { id: 2, name: 'Magyar Telekom' },
    { id: 3, name: 'Telenor' },
    { id: 4, name: 'Vodafone' },
    { id: 5, name: 'Other' },
  ],
  simLockDE: [
    { id: 1, name: 'Unlocked' },
    { id: 2, name: 'Magyar Telekom' },
    { id: 3, name: 'Telenor' },
    { id: 4, name: 'Vodafone' },
    { id: 5, name: 'Other' },
  ],
  brands: [
    { id: 56, name: 'Acer' },
    { id: 89, name: 'AEG' },
    { id: 73, name: 'Akai' },
    { id: 6, name: 'Alcatel' },
    { id: 80, name: 'Alcor' },
    { id: 109, name: 'Allterco' },
    { id: 49, name: 'Allview' },
    { id: 27, name: 'Apple' },
    { id: 74, name: 'Archos' },
    { id: 58, name: 'Asus' },
    { id: 110, name: 'Bauknecht' },
    { id: 28, name: 'Becker' },
    { id: 43, name: 'Beex' },
    { id: 30, name: 'BlackBerry' },
    { id: 87, name: 'Boway' },
    { id: 111, name: 'Canon' },
    { id: 40, name: 'CAT' },
    { id: 134, name: 'Cat Berlin' },
    { id: 119, name: 'Clevo' },
    { id: 75, name: 'Concorde' },
    { id: 81, name: 'Coolpad' },
    { id: 126, name: 'Crosscall' },
    { id: 138, name: 'CUBOT' },
    { id: 133, name: 'Cyrus' },
    { id: 98, name: 'D-link' },
    { id: 112, name: 'Dell' },
    { id: 129, name: 'Digi' },
    { id: 52, name: 'Doogee' },
    { id: 35, name: 'Doro' },
    { id: 67, name: 'Elephone' },
    { id: 32, name: 'Emporia' },
    { id: 132, name: 'Energizer' },
    { id: 85, name: 'Estar' },
    { id: 34, name: 'Evolveo' },
    { id: 140, name: 'FOSSIL' },
    { id: 88, name: 'Fujitsu' },
    { id: 57, name: 'GIGABYTE' },
    { id: 105, name: 'GoPro' },
    { id: 48, name: 'GSMART' },
    { id: 107, name: 'Hammer' },
    { id: 103, name: 'Homtom' },
    { id: 13, name: 'HP' },
    { id: 39, name: 'HTC' },
    { id: 101, name: 'HTM' },
    { id: 18, name: 'Huawei' },
    { id: 25, name: 'Hyundai' },
    { id: 94, name: 'iLike' },
    { id: 51, name: 'Iocean' },
    { id: 62, name: 'Jiayu' },
    { id: 97, name: 'KAZAM' },
    { id: 136, name: 'KINDLE' },
    { id: 116, name: 'Kobo' },
    { id: 102, name: 'KODAK' },
    { id: 139, name: 'Koobe' },
    { id: 122, name: 'Land Rover' },
    { id: 77, name: 'Lazer' },
    { id: 66, name: 'Leagoo' },
    { id: 45, name: 'Lenovo' },
    { id: 44, name: 'Lenovo NPC' },
    { id: 84, name: 'Lenovo Think' },
    { id: 10, name: 'LG' },
    { id: 137, name: 'MAP' },
    { id: 113, name: 'Medion' },
    { id: 108, name: 'Meizu' },
    { id: 72, name: 'Microsoft' },
    { id: 93, name: 'MobiWire' },
    { id: 114, name: 'MSI' },
    { id: 117, name: 'MyPhone' },
    { id: 120, name: 'Navitel' },
    { id: 71, name: 'Navon' },
    { id: 60, name: 'Nextbook' },
    { id: 5, name: 'Nokia' },
    { id: 131, name: 'Odys' },
    { id: 135, name: 'OnePlus' },
    { id: 54, name: 'Option' },
    { id: 50, name: 'Overmax' },
    { id: 121, name: 'Packard Bell' },
    { id: 4, name: 'Panasonic' },
    { id: 53, name: 'Pipo' },
    { id: 104, name: 'Pocketbook' },
    { id: 41, name: 'Polaroid' },
    { id: 91, name: 'Posh' },
    { id: 55, name: 'Prestigio' },
    { id: 78, name: 'Qilive' },
    { id: 128, name: 'RAZER' },
    { id: 9, name: 'Samsung' },
    { id: 65, name: 'Samsung CAM' },
    { id: 29, name: 'Samsung NPC' },
    { id: 86, name: 'Selecline' },
    { id: 90, name: 'Sencor' },
    { id: 96, name: 'Sonim' },
    { id: 7, name: 'Sony' },
    { id: 82, name: 'Tecdesk' },
    { id: 92, name: 'Telefunken' },
    { id: 36, name: 'Telme' },
    { id: 130, name: 'Tinno' },
    { id: 115, name: 'Toshiba' },
    { id: 123, name: 'TrekStor' },
    { id: 42, name: 'Ubiquiti' },
    { id: 61, name: 'UMI' },
    { id: 83, name: 'Unitone' },
    { id: 106, name: 'Vernee' },
    { id: 69, name: 'Wayteq' },
    { id: 76, name: 'Xiaomi' },
    { id: 127, name: 'YU' },
    { id: 47, name: 'Yulong' },
    { id: 68, name: 'Zopo' },
    { id: 26, name: 'ZTE' },
  ],
  brandsTelekom: [
    { id: 56, name: 'Acer' },
    { id: 89, name: 'AEG' },
    { id: 73, name: 'Akai' },
    { id: 6, name: 'Alcatel' },
    { id: 80, name: 'Alcor' },
    { id: 109, name: 'Allterco' },
    { id: 49, name: 'Allview' },
    { id: 27, name: 'Apple' },
    { id: 74, name: 'Archos' },
    { id: 58, name: 'Asus' },
    { id: 110, name: 'Bauknecht' },
    { id: 28, name: 'Becker' },
    { id: 43, name: 'Beex' },
    { id: 30, name: 'BlackBerry' },
    { id: 87, name: 'Boway' },
    { id: 111, name: 'Canon' },
    { id: 40, name: 'CAT' },
    { id: 134, name: 'Cat Berlin' },
    { id: 119, name: 'Clevo' },
    { id: 75, name: 'Concorde' },
    { id: 81, name: 'Coolpad' },
    { id: 126, name: 'Crosscall' },
    { id: 138, name: 'CUBOT' },
    { id: 133, name: 'Cyrus' },
    { id: 98, name: 'D-link' },
    { id: 112, name: 'Dell' },
    { id: 129, name: 'Digi' },
    { id: 52, name: 'Doogee' },
    { id: 35, name: 'Doro' },
    { id: 67, name: 'Elephone' },
    { id: 32, name: 'Emporia' },
    { id: 132, name: 'Energizer' },
    { id: 85, name: 'Estar' },
    { id: 34, name: 'Evolveo' },
    { id: 140, name: 'FOSSIL' },
    { id: 88, name: 'Fujitsu' },
    { id: 57, name: 'GIGABYTE' },
    { id: 105, name: 'GoPro' },
    { id: 48, name: 'GSMART' },
    { id: 107, name: 'Hammer' },
    { id: 103, name: 'Homtom' },
    { id: 13, name: 'HP' },
    { id: 39, name: 'HTC' },
    { id: 101, name: 'HTM' },
    { id: 18, name: 'Huawei' },
    { id: 25, name: 'Hyundai' },
    { id: 94, name: 'iLike' },
    { id: 51, name: 'Iocean' },
    { id: 62, name: 'Jiayu' },
    { id: 97, name: 'KAZAM' },
    { id: 136, name: 'KINDLE' },
    { id: 116, name: 'Kobo' },
    { id: 102, name: 'KODAK' },
    { id: 139, name: 'Koobe' },
    { id: 122, name: 'Land Rover' },
    { id: 77, name: 'Lazer' },
    { id: 66, name: 'Leagoo' },
    { id: 45, name: 'Lenovo' },
    { id: 10, name: 'LG' },
    { id: 137, name: 'MAP' },
    { id: 113, name: 'Medion' },
    { id: 108, name: 'Meizu' },
    { id: 72, name: 'Microsoft' },
    { id: 93, name: 'MobiWire' },
    { id: 114, name: 'MSI' },
    { id: 117, name: 'MyPhone' },
    { id: 120, name: 'Navitel' },
    { id: 71, name: 'Navon' },
    { id: 60, name: 'Nextbook' },
    { id: 5, name: 'Nokia' },
    { id: 131, name: 'Odys' },
    { id: 135, name: 'OnePlus' },
    { id: 54, name: 'Option' },
    { id: 50, name: 'Overmax' },
    { id: 121, name: 'Packard Bell' },
    { id: 4, name: 'Panasonic' },
    { id: 53, name: 'Pipo' },
    { id: 104, name: 'Pocketbook' },
    { id: 41, name: 'Polaroid' },
    { id: 91, name: 'Posh' },
    { id: 55, name: 'Prestigio' },
    { id: 78, name: 'Qilive' },
    { id: 128, name: 'RAZER' },
    { id: 9, name: 'Samsung' },
    { id: 86, name: 'Selecline' },
    { id: 90, name: 'Sencor' },
    { id: 96, name: 'Sonim' },
    { id: 7, name: 'Sony' },
    { id: 82, name: 'Tecdesk' },
    { id: 92, name: 'Telefunken' },
    { id: 36, name: 'Telme' },
    { id: 130, name: 'Tinno' },
    { id: 115, name: 'Toshiba' },
    { id: 123, name: 'TrekStor' },
    { id: 42, name: 'Ubiquiti' },
    { id: 61, name: 'UMI' },
    { id: 83, name: 'Unitone' },
    { id: 106, name: 'Vernee' },
    { id: 69, name: 'Wayteq' },
    { id: 76, name: 'Xiaomi' },
    { id: 127, name: 'YU' },
    { id: 47, name: 'Yulong' },
    { id: 68, name: 'Zopo' },
    { id: 26, name: 'ZTE' },
  ],
  brandsTMX: [
    { id: 58, name: 'Asus' },
    { id: 40, name: 'CAT' },
    { id: 18, name: 'Huawei' },
    { id: 45, name: 'Lenovo' },
    { id: 44, name: 'Lenovo NPC' },
    { id: 84, name: 'Lenovo Think' },
    { id: 9, name: 'Samsung' },
    { id: 65, name: 'Samsung CAM' },
    { id: 76, name: 'Xiaomi' },
  ],
};

const getters = {
  // this is a comment
};

const actions = {

};

const mutations = {

};

export default {
  state,
  actions,
  mutations,
  getters,
};
